import { render, staticRenderFns } from "./CurrentSituation.vue?vue&type=template&id=7267c5f4"
import script from "./CurrentSituation.vue?vue&type=script&lang=js"
export * from "./CurrentSituation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports